import React from 'react'

import Confetti from 'react-confetti'

const CONFETTI_COLORS = ['#13bdc3', '#086E88', '#277CF4', '#CE3197']
const CONFETTI_COUNT = 500

interface ConfettiWrapperProps {
    width: number
    height: number
    shouldParty: boolean
}

export const drawConfettiShape = (ctx: CanvasRenderingContext2D) => {
    ctx.beginPath()
    ctx.rect(1, 1, 10, 20)
    ctx.fill()

    ctx.closePath()
}

export const ConfettiWrapper: React.FC<ConfettiWrapperProps> = ({ width, height, shouldParty }) => (
    <Confetti
        width={width}
        height={height}
        numberOfPieces={shouldParty ? CONFETTI_COUNT : 0}
        recycle={false}
        colors={CONFETTI_COLORS}
        drawShape={drawConfettiShape}
    />
)
